import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

type RemoveAccessModalProps = {
  open: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  fundName: string;
};

export const RemoveAccessModal = ({
  open,
  onClose,
  onConfirm,
  fundName,
}: RemoveAccessModalProps) => (
  <ActionaryModal
    ModalButtonsGroupProps={{
      mainActionText: m.common_remove(),
      mainActionVariant: "destructive",
      secondaryActionLabel: m.btn_cancel(),
      mainAction: onConfirm,
      secondaryAction: onClose,
    }}
    dataTestId="remove-access-modal"
    description={m.userManagement_permissions_revokeAccessWarning()}
    fluidHeight
    open={open}
    setOpen={onClose}
    title={m.userManagement_permissions_modalRemoveAccess({ fundName })}
  />
);
